import React, { useState } from 'react';

const LoginForm = ({
  settings,
  loginError,
  onLogin,
  onForgotPassword,
  onResetPassword
}) => {
  const [showForgotPasswordForm, setShowForgotPasswordForm] = useState(false);
  const [showResetPasswordForm, setShowResetPasswordForm] = useState(false);
  const [resetToken, setResetToken] = useState('');

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    await onLogin(formData.get('username'), formData.get('password'));
  };

  const handleForgotPasswordSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    await onForgotPassword(formData.get('email'));
  };

  const handleResetPasswordSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    await onResetPassword(
      resetToken,
      formData.get('new_password'),
      formData.get('confirm_password')
    );
  };

  return (
    <div className="login-container" data-testid="login-container">
      <div className="login-card">
        <div className="login-header">
          <img
            src="/maraichpro-logo.png"
            alt="MaraichPro"
            className="login-logo"
            data-testid="login-logo"
          />
          <p className="subtitle">Gestion Maraîcher Professionnelle</p>
        </div>
        
        {!showForgotPasswordForm && !showResetPasswordForm ? (
          // Formulaire de connexion
          <form onSubmit={handleLoginSubmit} className="login-form" data-testid="login-form">
            <div className="form-group">
              <label>Nom d'utilisateur</label>
              <input
                type="text"
                name="username"
                required
                placeholder="Entrez votre nom d'utilisateur"
                data-testid="login-username"
              />
            </div>
            <div className="form-group">
              <label>Mot de passe</label>
              <input
                type="password"
                name="password"
                required
                placeholder="Entrez votre mot de passe"
                data-testid="login-password"
              />
            </div>
            {loginError && (
              <div className="error-message" data-testid="login-error">
                {loginError}
              </div>
            )}
            <button type="submit" className="btn btn-primary btn-login" data-testid="login-submit">
              Se connecter
            </button>
            <div className="login-links">
              <button 
                type="button" 
                className="forgot-password-link"
                onClick={() => setShowForgotPasswordForm(true)}
                data-testid="forgot-password-link"
              >
                Mot de passe oublié ?
              </button>
              <span className="link-separator"> | </span>
              <button 
                type="button" 
                className="forgot-password-link"
                onClick={() => setShowResetPasswordForm(true)}
                data-testid="reset-token-link"
              >
                J'ai un token de réinitialisation
              </button>
            </div>
          </form>
        ) : showForgotPasswordForm ? (
          // Formulaire mot de passe oublié
          <form onSubmit={handleForgotPasswordSubmit} className="login-form" data-testid="forgot-password-form">
            <div className="forgot-password-header">
              <h3>Réinitialiser le mot de passe</h3>
              <p>Entrez votre adresse email pour recevoir un token de réinitialisation</p>
            </div>
            <div className="form-group">
              <label>Adresse email</label>
              <input
                type="email"
                name="email"
                required
                placeholder="Entrez votre adresse email"
                data-testid="forgot-email"
              />
            </div>
            <div className="form-actions-row">
              <button 
                type="button" 
                className="btn btn-secondary"
                onClick={() => setShowForgotPasswordForm(false)}
              >
                Retour
              </button>
              <button type="submit" className="btn btn-primary" data-testid="forgot-submit">
                Envoyer le token
              </button>
            </div>
          </form>
        ) : (
          // Formulaire de réinitialisation avec token
          <form onSubmit={handleResetPasswordSubmit} className="login-form" data-testid="reset-password-form">
            <div className="forgot-password-header">
              <h3>Nouveau mot de passe</h3>
              <p>Entrez votre token de réinitialisation et votre nouveau mot de passe</p>
            </div>
            <div className="form-group">
              <label>Token de réinitialisation</label>
              <input
                type="text"
                name="token"
                required
                placeholder="Collez votre token ici"
                value={resetToken}
                onChange={(e) => setResetToken(e.target.value)}
                data-testid="reset-token"
              />
            </div>
            <div className="form-group">
              <label>Nouveau mot de passe</label>
              <input
                type="password"
                name="new_password"
                required
                placeholder="Au moins 8 caractères"
                minLength="8"
                data-testid="reset-new-password"
              />
            </div>
            <div className="form-group">
              <label>Confirmer le mot de passe</label>
              <input
                type="password"
                name="confirm_password"
                required
                placeholder="Confirmez votre nouveau mot de passe"
                minLength="8"
                data-testid="reset-confirm-password"
              />
            </div>
            <div className="form-actions-row">
              <button 
                type="button" 
                className="btn btn-secondary"
                onClick={() => setShowResetPasswordForm(false)}
              >
                Retour
              </button>
              <button type="submit" className="btn btn-primary" data-testid="reset-submit">
                Réinitialiser
              </button>
            </div>
          </form>
        )}
        
        <div className="login-footer">
          <div className="branding">
            <p>Made by <a href="https://www.maraichpro.com" target="_blank" rel="noopener noreferrer"><strong>Maraich'Pro</strong></a></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
